import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../hooks/AuthContext";

const RequireAuth = ({ isAuthPage = false }) => {
  const { isAuthenticated, isAuthReady } = useContext(AuthContext);

  if (!isAuthReady) {
    return null;
  }

  if (isAuthPage) {
    return !isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default RequireAuth;
